<template>
  <v-container>
    <h1 style="text-align: center" class="pt-2">Vous êtes?</h1>
    <v-row justify="center">
      <v-col cols="12" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            :elevation="hover ? 20 : 2"
            class="grow"
            to="register/gym"
            :ripple="false"
          >
            <v-card-title class="align-center fill-height grad"
              >Gym</v-card-title
            >
            <v-img
              src="@/assets/images/gym.jpg"
              alt="salle de sport en tunisie"
            ></v-img>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            :elevation="hover ? 20 : 2"
            to="register/coach"
            class="grow"
            :ripple="false"
          >
            <v-card-title class="align-end fill-height grad"
              >Coach Personnel</v-card-title
            >
            <v-img
              src="@/assets/images/personal-trainer.jpg"
              alt="coach personnel en tunisie"
            ></v-img>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            :elevation="hover ? 20 : 2"
            to="register/physio"
            class="grow"
            :ripple="false"
          >
            <v-card-title class="align-end fill-height grad">Kiné</v-card-title>
            <v-img src="@/assets/images/kine.jpg" alt="Kiné en tunisie"></v-img>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" md="3">
        <v-hover v-slot:default="{ hover }">
          <v-card
            :elevation="hover ? 20 : 2"
            to="register/nutrition"
            class="grow"
            :ripple="false"
          >
            <v-card-title class="align-end fill-height grad"
              >Nutritionniste</v-card-title
            >
            <v-img
              src="@/assets/images/nut.jpeg"
              height="180"
              alt="nutritionniste en tunisie"
            ></v-img>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      freeGym: [
        {
          label: "Photo",
          value: 1,
        },
        {
          label: "Planning",
          icon: "fas fa-check",
        },
        {
          label: "Events",
          icon: "fas fa-times",
        },
        {
          label: "Contact",
          icon: "fas fa-check",
        },
      ],
      premiumGym: [
        {
          label: "Photos",
          value: 3,
        },
        {
          label: "Planning",
          icon: "fas fa-check",
        },
        {
          label: "Events",
          icon: "fas fa-check",
        },
        {
          label: "Contact",
          icon: "fas fa-check",
        },
      ],
      premiumCoach: [
        {
          label: "Photos",
          value: 3,
        },
        {
          label: "Planning",
          icon: "fas fa-check",
        },
        {
          label: "Events",
          icon: "fas fa-check",
        },
        {
          label: "Contact",
          icon: "fas fa-check",
        },
      ],
      premiumStore: [
        {
          label: "Photos",
          value: 2,
        },
        {
          label: "Planning",
          icon: "fas fa-check",
        },
        {
          label: "Events",
          icon: "fas fa-check",
        },
        {
          label: "Contact",
          icon: "fas fa-check",
        },
      ],
    };
  },
};
</script>

<style scoped>
.grad {
  background-image: linear-gradient(to right, #e52d27 0%, #b31217 51%);
}
.grad:hover {
  background-position: right center;
}
.grow {
  transition: all 0.2s ease-in-out;
}
.grow:hover {
  transform: scale(1.02);
}
</style>
